import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { checkEnabledFeature, getKeyFeaturesConfig } from 'utils/function';
import { CONFIG } from 'constants/index';
import { PermissionType } from 'models';
import { useMemo } from 'react';

const getFeature = (object: {
  features?: PermissionType[] | undefined;
}): PermissionType[] | [] => {
  return object?.features || [];
};

const isEnabled = (object: { enabled: boolean }): boolean => {
  return object?.enabled;
};

export function usePcManagementPermission() {
  const { permission } = useSelector((state: RootState) => state.configReducer);
  const { pcManagement } = permission;
  const pcManagementFeature = getFeature(pcManagement);
  const isPcManagementEnabled = isEnabled(pcManagement);

  const getMyTechnology = getKeyFeaturesConfig(
    pcManagementFeature,
    CONFIG.PC_MANAGEMENT.MY_TECHNOLOGY,
  );

  const getShowPrimaryLabel = getKeyFeaturesConfig(
    getFeature(getMyTechnology),
    CONFIG.PC_MANAGEMENT.SHOW_PRIMARY_LABEL,
  );
  const isShowPrimaryLabel =
    isPcManagementEnabled && checkEnabledFeature(getShowPrimaryLabel);

  const getShowSerialNumber = getKeyFeaturesConfig(
    getFeature(getMyTechnology),
    CONFIG.PC_MANAGEMENT.SHOW_SERIAL_NUMBER,
  );
  const isShowSerialNumber =
    isPcManagementEnabled && checkEnabledFeature(getShowSerialNumber);

  const getShowLastScanned = getKeyFeaturesConfig(
    getFeature(getMyTechnology),
    CONFIG.PC_MANAGEMENT.SHOW_LAST_SCANNED,
  );
  const isShowLastScanned =
    isPcManagementEnabled && checkEnabledFeature(getShowLastScanned);

  const getShowAssigned = getKeyFeaturesConfig(
    getFeature(getMyTechnology),
    CONFIG.PC_MANAGEMENT.SHOW_ASSIGNED,
  );
  const isShowAssigned =
    isPcManagementEnabled && checkEnabledFeature(getShowAssigned);

  return useMemo(
    () => ({
      isShowPrimaryLabel,
      isShowSerialNumber,
      isShowLastScanned,
      isShowAssigned,
    }),
    [pcManagement],
  );
}
